import type { PassioResponseMeta } from "./meta";

export class PassioApiError extends Error {
  readonly status: number;
  readonly body: unknown;
  readonly meta?: PassioResponseMeta;
  /** Machine-readable code when the body carries one (proxy limit errors use this). */
  readonly code?: string;

  constructor(message: string, opts: { status: number; body?: unknown; meta?: PassioResponseMeta; code?: string }) {
    super(message);
    this.name = "PassioApiError";
    this.status = opts.status;
    this.body = opts.body;
    this.meta = opts.meta;
    this.code = opts.code;
  }

  static async fromResponse(res: Response, meta: PassioResponseMeta): Promise<PassioApiError> {
    const text = await res.text().catch(() => "");
    let body: unknown = text;
    try {
      body = text ? JSON.parse(text) : undefined;
    } catch {
      /* keep text */
    }
    const b = (body && typeof body === "object" ? body : {}) as Record<string, unknown>;
    // Passio API errors are `{ code: <http status>, cause }`; the demo proxy sends `{ error, code: "<slug>" }`.
    const detail = [b.message, b.error, b.cause, b.detail, b.title].find((x) => typeof x === "string" && x) as string | undefined;
    const message = detail || (typeof body === "string" && body ? body.slice(0, 300) : `HTTP ${res.status} ${res.statusText}`);
    return new PassioApiError(message, {
      status: res.status,
      body,
      meta,
      code: typeof b.code === "string" ? b.code : undefined,
    });
  }
}
